import React from "react"
import PropTypes from "prop-types"
import accounting from 'accounting'

import PaymentItemContainer from "../containers/PaymentItemContainer"
import PaymentFormContainer from "../containers/PaymentFormContainer"

export default class Payments extends React.Component {
  componentWillMount() {
    this.props.fetchPayments()
    this.props.fetchPaymentTotals()
  }

  render () {
    const { payments, totalAmountOwed, totalAmountPaid } = this.props
    return (
      <table className="table table-responsive table-sm">
        <thead className="thead-default">
          <tr>
            <th>Due date</th>
            <th>Date paid</th>
            <th>Description</th>
            <th>Owed</th>
            <th>Paid</th>
            <th>Balance</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            payments.length > 0 ? (
              payments.map((payment) => (
                <PaymentItemContainer
                  key={payment.id}
                  payment={payment}
                  organizationId={this.props.organization_id}
                  residentId={this.props.resident_id} />
              ))
            ) : (
              <tr>
                <td colSpan="6">No payments to show</td>
              </tr>
            )
          }
        </tbody>
        <tfoot className="thead-default">
          <tr>
            <th colSpan="3">Totals</th>
            <td>{accounting.formatMoney(totalAmountOwed)}</td>
            <td>{accounting.formatMoney(totalAmountPaid)}</td>
            <td>{accounting.formatMoney(totalAmountOwed - totalAmountPaid)}</td>
            <td />
          </tr>
        </tfoot>
      </table>
    )
  }
}
